// extracted by mini-css-extract-plugin
export default {"img":"Preloader_img__5MWCa"};